<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->

  <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  <router-view />
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  watch: {
    // 监听路由变化，实时修改标题
    $route: {
      immediate: true, // 初始加载就执行
      handler (to) {
        const pageTitle = `${to.meta.title || '小熊智教'} - 小熊智教`;
        document.title = pageTitle; // 原生API，所有浏览器都生效
        // console.log('设置标题：', pageTitle); // 验证是否执行
      }
    }
  },
  // computed: {
  //   pageTitle () {
  //     // 兼容meta.title为空的情况，避免显示"undefined - 小熊智教"
  //     return `${this.$route.meta.title} - 小熊智教`
  //   }
  // },
  // created () {
  //   console.log(this.pageTitle)
  // }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
body {
  margin: 0;
}
</style>
